import { useEffect } from 'react'

import { EVENT_NAME_MOUSE_DOWN } from '../../../../constants/event'

import {
  ARIA_EXPANDED_ATTRIBUTE,
  CHEVRON_SELECTOR,
} from './useEditorToolbarOverflowClose.constants'
import {
  getAuxContainers,
  getOverflowDrawer,
  isAriaExpanded,
  isDrawerOpen,
  shouldIgnoreMouseDown,
} from './useEditorToolbarOverflowClose.utils'

export function useEditorToolbarOverflowClose({ editorInitiated, editorRef }) {
  useEffect(() => {
    if (editorInitiated) {
      const container = editorRef.current?.getContainer?.()

      if (container) {
        let closeTimeoutId = null

        function handleDocumentMouseDown(event) {
          const chevron = container.querySelector(CHEVRON_SELECTOR)
          const drawer = getOverflowDrawer(container)
          // In floating toolbar mode the drawer lives in the editor's own aux
          // container, so with several editors on the page every aux counts.
          const auxContainers = getAuxContainers()

          if (
            shouldIgnoreMouseDown({
              auxContainers,
              chevron,
              container,
              drawer,
              target: event.target,
            })
          ) {
            return
          }

          clearTimeout(closeTimeoutId)
          closeTimeoutId = setTimeout(() => {
            closeTimeoutId = null

            if (isDrawerOpen(chevron, container)) {
              chevron.click()
            }
          }, 0)
        }

        const blurObserver = new MutationObserver(records => {
          records.forEach(({ target }) => {
            if (target.matches?.(CHEVRON_SELECTOR) && !isAriaExpanded(target)) {
              target.blur()
            }
          })
        })

        blurObserver.observe(container, {
          attributeFilter: [ARIA_EXPANDED_ATTRIBUTE],
          attributes: true,
          subtree: true,
        })

        document.addEventListener(
          EVENT_NAME_MOUSE_DOWN,
          handleDocumentMouseDown
        )

        return () => {
          document.removeEventListener(
            EVENT_NAME_MOUSE_DOWN,
            handleDocumentMouseDown
          )
          blurObserver.disconnect()
          clearTimeout(closeTimeoutId)
        }
      }
    }
  }, [editorInitiated])
}
